import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"

interface Props {
  showInHeader?: boolean
  showWidgetInPage?: boolean
}

interface RectangleProps {
  color: string
}

export const WidgetsContainer = styled(Flex)`
  ${({theme}) => css`
    flex-direction: column;
    ${theme.mediaQueries.minWidthMedia.desktop`
      flex-direction: row;
    `}
  `}
`

export const StyledCard = styled(Card)<Props>`
  ${({showInHeader, theme}) => css`
    ${!showInHeader && "margin-top: 20px"};
    ${showInHeader && "width: 310px"};
    border-radius: ${theme.border.radius.medium};
    flex: 1;

    ${theme.mediaQueries.minWidthMedia.tablet`
      display: ${showInHeader ? "block" : "none"}
    `}
  `}
`

export const CardInsidePage = styled(Card)`
  flex: 1;
  ${({theme}) => css`
    border-radius: ${theme.border.radius.medium};
  `}
`

export const TopBrandsWrapper = styled(Card)`
  flex: 1;
  ${({theme}) => css`
    border-radius: ${theme.border.radius.medium};
    order: 2;
    ${theme.mediaQueries.minWidthMedia.desktop`
      order: 1;
    `}
  `}
`

export const TotalSavings = styled.p<Props>`
  ${({showWidgetInPage, theme}) => css`
    margin: 0;
    display: flex;
    color: ${theme.colors.greys.black};
    font-family: ${theme.font.semibold};
    font-size: ${showWidgetInPage ? "40px" : "32px"};
    font-weight: 700;
    line-height: 32px; /* 83.333% */
    letter-spacing: -0.3px;
  `}
`

export const BrandLogoUrl = styled.div<{logoUrl: string}>`
  ${({theme, logoUrl}) => css`
    background-image: url(${logoUrl});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 100%;
    min-width: 50px;
    height: 50px;
    border: 1px solid ${theme.colors.greys.grey20};
  `}
`

export const PieChartCardInsidePage = styled(Card)`
  ${({theme}) => css`
    flex: 1;
    border-radius: ${theme.border.radius.medium};
    order: 1;
    ${theme.mediaQueries.minWidthMedia.desktop`
      order: 2;
    `}
  `}
`

export const Rectangle = styled.div<RectangleProps>`
  min-width: 16px;
  width: 16px;
  height: 16px;
  ${({color}) => `background-color: ${color};`}
  margin-right: 4px;
  border-radius: 4px;
`

export const StyledLink = styled(ButtonRouterLink)`
  text-align: left;
`

export const ChartWrapper = styled(Flex)`
  ${({theme}) => css`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.desktop`
      gap: ${theme.spacing.oneAndHalf};
      flex-direction: row;
    `}
  `}
`

export const Legend = styled(Flex)`
  ${({theme}) => css`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    ${theme.mediaQueries.minWidthMedia.desktop`
      flex-direction: column;
      width: 50%;
    `}
  `}
`
